export enum ViewBuilderMode {
    /**
     * See a View definition in Preview Mode.
     */
    PREVIEW,
    /**
     * Create or Edit a View.
     */
    EDITOR,
}
